import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import MFAVerification from './components/MFAVerification';
import MainLayout from './components/Layout/MainLayout';
import Dashboard from './components/Dashboard';
import UserManagement from './components/UserManagement';
import LicenseManagement from './components/LicenseManagement';
import UserDetail from './components/UserDetail';
import LicenseDetail from './components/LicenseDetail';
import { getAuthToken, setAuthToken, clearAuthToken } from './services/auth';
import './App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const token = getAuthToken();
    setIsAuthenticated(!!token);
    setIsLoading(false);
  }, []);

  const handleLogin = (token) => {
    setAuthToken(token);
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    clearAuthToken();
    setIsAuthenticated(false);
  };

  if (isLoading) {
    return <div className="admin-loading">Lade Admin-Panel...</div>;
  }

  return (
    <Router>
      <Routes>
        <Route path="/admin/login" element={
          !isAuthenticated ? <Login onLogin={handleLogin} /> : <Navigate to="/admin/dashboard" />
        } />
        <Route path="/admin/mfa" element={
          !isAuthenticated ? <MFAVerification onLogin={handleLogin} /> : <Navigate to="/admin/dashboard" />
        } />
        <Route path="/admin/*" element={
          isAuthenticated ? (
            <MainLayout onLogout={handleLogout}>
              <Routes>
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="users" element={<UserManagement />} />
                <Route path="users/:id" element={<UserDetail />} />
                <Route path="licenses" element={<LicenseManagement />} />
                <Route path="licenses/:key" element={<LicenseDetail />} />
                <Route path="*" element={<Navigate to="/admin/dashboard" />} />
              </Routes>
            </MainLayout>
          ) : <Navigate to="/admin/login" />
        } />
        <Route path="/admin" element={<Navigate to="/admin/dashboard" />} />
      </Routes>
    </Router>
  );
}

export default App;






